function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import Svg from "../Svg";
var Icon = function(props) {
    return /*#__PURE__*/ _jsx(Svg, _objectSpread({
        viewBox: "0 0 26 26"
    }, props, {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M1.437 7.027h1.625v-3.3c0-.512.425-.937.938-.937.512 0 .937.425.937.937v3.288h1.625c.513 0 .938.425.938.937v7.4a.944.944 0 0 1-.938.938H4.938v1.712A.944.944 0 0 1 4 18.94a.944.944 0 0 1-.938-.938V16.29H1.437a.944.944 0 0 1-.937-.938V7.965c0-.525.425-.938.937-.938ZM10.537 8.515H12.1V4.652c0-.512.425-.937.937-.937.513 0 .938.425.938.937v3.85h1.562c.513 0 .938.425.938.938v12.025a.944.944 0 0 1-.938.937h-1.55v1.7a.944.944 0 0 1-.937.938.944.944 0 0 1-.938-.938v-1.7H10.55a.944.944 0 0 1-.938-.937V9.452a.91.91 0 0 1 .925-.937ZM19.438 2.54h1.625V.965c0-.512.425-.937.937-.937s.938.425.938.937V2.54h1.625c.512 0 .937.413.937.938v11.8a.944.944 0 0 1-.938.937h-1.625v2.663a.944.944 0 0 1-.937.937.944.944 0 0 1-.938-.937v-2.663h-1.625a.944.944 0 0 1-.937-.937v-11.8c0-.525.425-.938.938-.938Z",
            fill: "#194BFB"
        })
    }));
};
export default Icon;
